import {createButtonComponent, IButtonProperties} from '@vfde-brix-ws10/button';

/**
 * Export mountButton
 *
 * @export mountButton
 */
const mountButton = (target, props: IButtonProperties) => {

    return createButtonComponent(target, props);

};

export default mountButton;
